import type { BaseResponse, ListResponse, PaginationData } from '@/utils/request';
import { request } from '@/utils/request';

// ====== 钱包相关 ======

/** 获取钱包余额 */
export function getAccountBalance() {
  return request<BaseResponse<API.GetAccountBalance>>({
    url: '/newapi/user/wallets/getAccountBalance',
    method: 'get',
  });
}

/** 钱包资金记录 */
export function getWalletRecords(data: { page: number, limit: number, type?: string }) {
  return request<ListResponse<API.WalletRecord[]>>({
    url: '/newapi/user/wallets/getDetails',
    method: 'get',
    data,
  });
}

/** 获取提现账号 */
export function getWithdrawalAccount() {
  return request<API.WithdrawAccount[]>({
    url: '/newapi/user/wallets/getWithdrawalIdInfo',
    method: 'get',
  });
}

/** 绑定提现账号 */
export function bindWithdrawalAccount(data: API.SetWithdrawalIdInfoParams) {
  return request<BaseResponse<any>>({
    url: '/newapi/user/wallets/setWithdrawalIdInfo',
    method: 'post',
    data,
  }, {
    notificationType: 'all',
  });
}

/** 申请提现 */
export function applyWithdrawal(data: API.ApplyWithdrawalParams) {
  return request<BaseResponse<any>>({
    url: '/newapi/user/wallets/applyWithdrawal',
    method: 'post',
    data,
  }, {
    notificationType: 'all',
  });
}

/** 获取提现记录 */
export function getWithdrawalRecords(data: { page: number, limit: number }) {
  return request<PaginationData<API.WithdrawalInfo[]>>({
    url: '/newapi/user/wallets/getWithdrawalRecords',
    method: 'post',
    data,
  });
}

/** 获取提现信息/进度 */
export function getWithdrawalInfo(type: number) {
  return request<API.WithdrawalInfo>({
    url: '/newapi/user/wallets/getWithdrawalInfo',
    method: 'get',
    data: {
      type,
    },
  });
}

// ====== 上货积分相关 ======

/** 获取剩余上货积分 */
export function getIntegralInfo(data: Record<string, any> = {}) {
  return request<any>({
    url: '/newapi/user/usersSelfIntegral/getIntegralInfo',
    method: 'post',
    data,
  });
}

/** 获取积分充值记录（购买明细） */
export function getIntegralOrderList(data: Record<string, any>) {
  return request<PaginationData<API.IntegralOrderItem[]>>({
    url: '/newapi/user/usersSelfIntegral/getUserIntegralOrderList',
    method: 'post',
    data,
  });
}

/** 余额充值 */
export function alipayRecharge(data: Record<string, any>) {
  return request<BaseResponse<any>>({
    url: '/pay/rechargePay',
    method: 'post',
    data,
  }, {
    notificationType: 'error',
  });
}

/** 外部扫码充值支付（PC扫码打开H5） */
export function rechargePayExternal(data: Record<string, any>) {
  return request<BaseResponse<{ url: string }>>({
    url: '/pay/rechargePayM',
    method: 'post',
    data,
  }, {
    notificationType: 'error',
  });
}

/** 上货积分充值 */
export function addIntegralByAmount(integralTypeId: number) {
  return request<BaseResponse<any>>({
    url: '/newapi/user/usersSelfIntegral/addIntegralByAmount',
    method: 'post',
    data: {
      integralTypeId,
    },
  }, {
    notificationType: 'all',
  });
}

/** 查询购买积分类型 */
export function getIntegralTypeList(data: Record<string, any> = {}) {
  return request<API.RechargeIntegralItem[]>({
    url: '/newapi/user/usersSelfIntegral/getUserIntegralTypeList',
    method: 'post',
    data,
  });
}

/** 上货积分退款 */
export function refundIntegralToAmount(data: Record<string, any>) {
  return request<BaseResponse<any>>({
    url: '/newapi/user/usersSelfIntegral/refundIntegralToAmount',
    method: 'post',
    data,
  }, {
    notificationType: 'all',
  });
}

/** 获取积分流水类型选项 */
export function getIntegralFlowType(data: Record<string, any> = {}) {
  return request<API.IntegralFlowTypeItem[]>({
    url: '/newapi/user/usersSelfIntegral/getIntegralFlowType',
    method: 'post',
    data,
  });
}

/** 获取积分流水列表 */
export function getIntegralFlow(data: Record<string, any>) {
  return request<ListResponse<API.IntegralFlowItem[]>>({
    url: '/newapi/user/usersSelfIntegral/getIntegralFlow',
    method: 'post',
    data,
  });
}
